import { useFormik } from "formik";
import {
  editproduct,
  getallcategory,
  getallsubcategory,
} from "../../service/Mainservice";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Modal } from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import Loader from "../../Loader/Loader";

const validate = (values) => {
  const errors = {};

  if (!values.name) {
    errors.name = "Required";
  }
  if (!values.about) {
    errors.about = "Required";
  }
  if (!values.price) {
    errors.price = "Required";
  }
  if (!values.category) {
    errors.category = "Required";
  }
  if (!values.subcategory) {
    errors.subcategory = "Required";
  }
  return errors;
};

const style = {
  position: "absolute",
  top: { xs: "60%", sm: "50%" },
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "95%", sm: "562px" },
  bgcolor: "#fff",
  p: 1,
  borderRadius: "4px",
  border: "none",
  outline: "none",
  // height: "140px",
};
export const Editproduct = ({ isopen, setisopen, items, getdata }) => {
  const [cat, setcat] = useState([]);
  const [subcat, setsubcat] = useState([]);
  const [load, setload] = useState(false);
  const [loading, setloading] = useState(true);
  const [preview, setPreview] = useState([]);
  const [removeid, setremoveid] = useState([]);
  const [file, setfile] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    getcategory();
    // getsubcategory("1");
    // let images = items.images.map((obj) => obj.image);
    setPreview(items.images);

    formik.setValues({
      name: items.name,
      about: items.about,
      price: items.price,
      category: items.category_id,
      subcategory: items.subcategory_id,
    });
  }, []);

  const formik = useFormik({
    initialValues: {
      name: "",
      about: "",
      price: "",
      category: "",
      subcategory: "",
    },
    validate,
    onSubmit: (values) => {
      console.log(values);
      handleAdd(values);
    },
  });

  useEffect(() => {
    getsubcategory(formik.values.category);
  }, [formik.values.category]);

  const getcategory = async () => {
    try {
      const responce = await getallcategory();
      setcat(responce.data.data);
      setloading(false);
    } catch (error) {
      console.log(error);
      setloading(false);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };
  const getsubcategory = async (value) => {
    try {
      const response = await getallsubcategory(value);
      if (response.data.data.length === 0) {
        setsubcat([{ id: 1, name: "No Subcategory" }]);
        formik.setFieldValue("subcategory", "");
      } else {
        setsubcat(response.data.data);
        formik.setFieldValue("subcategory", response.data.data[0].id);
      }
      setloading(false);
    } catch (error) {
      setloading(false);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };
  console.log(formik.values);
  const uploadMultipleFiles = (e) => {
    const files = e.target.files;
    let image = [];

    for (let i = 0; i < files.length; i++) {
      image.push(URL.createObjectURL(files[i]));
    }
    setfile(files);

    let newimg = image.map((value) => ({ image: value }));
    setPreview((pre) => [...pre, ...newimg]);

    // method:2
    // const selectedFIles =[];
    //     const targetFiles =e.target.files;
    //     const targetFilesObject= [...targetFiles]
    //     targetFilesObject.map((file)=>{
    //        return selectedFIles.push(URL.createObjectURL(file))
    //     })
    //     setPreview(selectedFIles);
  };

  const deleteFile = async (i, url) => {
    if (url.image.startsWith("blob:http")) {
      setPreview((pre) => pre.filter((item, index) => index !== i));
    } else {
      setPreview((pre) => pre.filter((item, index) => index !== i));
      setremoveid((pre) => [...pre, url.id]);
    }
  };

  const handleAdd = async (value) => {
    setload(true);
    try {
      const info = {
        id: items.id,
        info: value,
        cat: cat.find((i) => i.id === Number(formik.values.category)),
        image: file,
        removeimg: removeid,
      };
      console.log(info);
      const responce = await editproduct(info);

      getdata();
      setisopen(false);
      setload(false);
    } catch (error) {
      console.log(error);
      setload(false);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };
  return (
    <>
      <Modal
        open={isopen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        onClose={() => setisopen(false)}
        style={{
          backgroundColor: "rgb(0, 0, 0, 0.55)",
        }}
      >
        <Box sx={style}>
          <form onSubmit={formik.handleSubmit}>
            <h1 className="data_heading">Update Product</h1>
            <div>
              <label className="Auth_label">Product Name</label>

              <input
                onChange={formik.handleChange}
                name="name"
                type="text"
                placeholder="Product Name"
                minLength={1}
                maxLength={30}
                value={formik.values.name}
                className="Auth_input"
              />
              {formik.errors.name ? (
                <p className="invalid">{formik.errors.name} </p>
              ) : null}
            </div>
            <div>
              <label className="Auth_label">About Product</label>

              <input
                onChange={formik.handleChange}
                name="about"
                type="text"
                placeholder="About Product"
                minLength={1}
                maxLength={30}
                value={formik.values.about}
                className="Auth_input"
              />
              {formik.errors.about ? (
                <p className="invalid">{formik.errors.about} </p>
              ) : null}
            </div>
            <div>
              <label className="Auth_label"> Product Price</label>

              <input
                onChange={formik.handleChange}
                name="price"
                type="number"
                placeholder="Product Price"
                minLength={1}
                maxLength={30}
                value={formik.values.price}
                className="Auth_input"
              />
              {formik.errors.price ? (
                <p className="invalid">{formik.errors.price} </p>
              ) : null}
            </div>
            <div>
              <label className="Auth_label">Category Type</label>
              <br />
              <select
                onChange={formik.handleChange}
                name="category"
                className="Auth_input"
                value={formik.values.category}
                style={{ width: "99%" }}
              >
                {cat.map((i) => (
                  <option value={i.id}>{i.name}</option>
                ))}
              </select>
              {formik.errors.category ? (
                <p className="invalid">{formik.errors.category} </p>
              ) : null}
            </div>
            <div>
              <label className="Auth_label">SubCategory Type</label>
              <br />
              <select
                onChange={formik.handleChange}
                name="subcategory"
                className="Auth_input"
                value={formik.values.subcategory}
                style={{ width: "99%" }}
              >
                {subcat.map((i) => (
                  <option value={i.id}>{i.name}</option>
                ))}
              </select>
              {formik.errors.subcategory ? (
                <p className="invalid">{formik.errors.subcategory} </p>
              ) : null}
            </div>
            <label className="Auth_label">Product Image</label>
            <div className="room_img">
              {/* {preview ? (
              {
              }
            ) : (
                              <img src={preview} className="editprofile_img" /> 

            )} */}
              <div className="room_divviewimg">
                <input
                  type="file"
                  id="file"
                  accept="image/*"
                  onChange={uploadMultipleFiles}
                  name="profile_pic"
                  multiple
                />
                <label htmlFor="file" id="uploadbtn">
                  <CameraAltIcon className="room_cameraicn" />
                </label>
              </div>

              {preview?.map((url, i) => {
                let imgshow;
                if (url.image.startsWith("blob:http")) {
                  imgshow = url.image;
                } else {
                  imgshow = url.image;
                }
                return (
                  <div className="room_divviewimg">
                    <img src={imgshow} />
                    <HighlightOffIcon
                      id="deleteimg"
                      onClick={() => deleteFile(i, url)}
                    />
                  </div>
                );
              })}
            </div>

            <button className="Auth_button" type="submit">
              {load ? "Updating..." : "Save"}
            </button>
          </form>
          {loading && <Loader />}
        </Box>
      </Modal>
    </>
  );
};
